export default __webpack_public_path__ + "static/media/polgot-screenshot-01.fd478208.png";